module.exports = __webpack_public_path__ + "static/media/male_right.93f3ea0d.jpg";